export const PAGE_ACTION = {
  SHOW_LOADER: "page/SHOW_LOADER",
  HIDE_LOADER: "page/HIDE_LOADER",
  CHANGE_LOADER_MESSAGE: "page/CHANGE_LOADER_MESSAGE",
  RESET_LOADER_MESSAGE: "page/RESET_LOADER_MESSAGE",
  SHOW_SNACKBAR: "page/SHOW_SNACKBAR",
  HIDE_SNACKBAR: "page/HIDE_SNACKBAR",
};
